import React, { useRef, useState } from "react";
import * as Icons from "react-feather";
import { useClickDetecter } from "lib/helpers";
import { useAuth } from "store/auth";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";

export default function Account() {
  const [showMenu, setShowMenu] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const wrapperRef = useRef(null);
  const auth = useAuth();
  let navigate = useNavigate();

  useClickDetecter(wrapperRef, (flag) => {
    setShowMenu(flag);
  });
  const resetPassword = async () => {
    await auth.dispatch(auth.logout());
    navigate(`/auth/resetpassword`);
  };
  const logout = async () => {
    await auth.dispatch(auth.logout());
    navigate(`/auth/login`);
  };
  const changeSideBar = () => {
    auth.dispatch(auth.toggleSideBar());
    localStorage.setItem("sidebar", !auth.sidebar);
  };
  return (
    <>
      <div className="intro-x dropdown w-8 h-8" ref={wrapperRef}>
        <div
          onClick={() => setShowMenu(!showMenu)}
          className="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in scale-110"
          role="button"
          aria-expanded="false"
        >
          <img alt="vod" src="/images/account.jpg" />
        </div>
        <div
          className={`dropdown-menu w-56 ${showMenu ? "show" : ""}`}
          style={{
            width: 224,
            position: "absolute",
            inset: "0px auto auto 0px",
            margin: 0,
            transform: "translate(0px, 32px)",
          }}
        >
          <div className="dropdown-menu__content box bg-theme-26 dark:bg-dark-6 text-white">
            <div className="p-4 border-b border-theme-27 dark:border-dark-3">
              <div className="font-medium">
                {auth && auth.userMeta && auth.userMeta.full_name}
              </div>
              <div className="text-xs text-theme-28 mt-0.5 dark:text-gray-600">
                {auth && auth.userMeta && auth.userMeta.user_name}
              </div>
            </div>
            <div className="p-2">
              <a
                href="javascript:;"
                onClick={() => setShowProfile(true)}
                className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
              >
                <Icons.User className="w-4 h-4 ml-2" /> پروفایل{" "}
              </a>
              <a
                href="javascript:;"
                onClick={resetPassword}
                className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
              >
                <Icons.Lock className="w-4 h-4 ml-2" /> تغییر کلمه عبور{" "}
              </a>
              <a
                href="javascript:;"
                onClick={() => changeSideBar()}
                className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
              >
                <Icons.ToggleLeft className="w-4 h-4 ml-2" />
                {auth.sidebar ? "منوی نواری" : "منوی سایدبار"}
              </a>
              <a
                href="javascript:;"
                className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
              >
                <Icons.HelpCircle className="w-4 h-4 ml-2" /> راهنما{" "}
              </a>
            </div>
            <div className="p-2 border-t border-theme-27 dark:border-dark-3">
              <a
                href="javascript:;"
                onClick={logout}
                className="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
              >
                <Icons.LogOut className="w-4 h-4 ml-2" /> خروج{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showProfile}
        handleClose={() => setShowProfile(false)}
        title="اطلاعات کاربر"
      >
        <div className="p-3 grid grid-cols-2">
          <div className="p-3 flex items-center justify-center">
            <img
              className="rounded-full h-48 w-48 object-cover"
              src={
                (auth.userMeta && auth.userMeta.avatar) || "/images/account.jpg"
              }
              alt=""
            />
          </div>
          <div>
            <p className="p-1">
              <span className="text-sm">نام : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.first_name}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">نام خانوادگی : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.last_name}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">نام کاربری : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.user_name}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">تاریخ تولد : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.birthday}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">کشور : </span>
              <span className="text-theme-10">
                {auth.userMeta &&
                  auth.userMeta.country &&
                  auth.userMeta.country.fa_name}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">تاریخ ایجاد اکانت : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.created_at}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">تاریخ تایید اکانت : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.verified_at}
              </span>
            </p>
            <p className="p-1">
              <span className="text-sm">آخرین بروز رسانی اکانت : </span>
              <span className="text-theme-10">
                {auth.userMeta && auth.userMeta.updated_at}
              </span>
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
}
